import React from "react";
import type { IconProps } from "./types";

export const GithubIcon = React.forwardRef<SVGSVGElement, IconProps>(
  function GithubIcon(
    {
      size = 24,
      width,
      height,
      className = "",
      fill = "currentColor",
      ...props
    },
    ref
  ) {
    return (
      <svg
        ref={ref}
        width={width || size}
        height={height || size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2C6.477 2 2 6.477 2 12C2 16.42 4.865 20.125 8.839 21.49C9.339 21.58 9.521 21.272 9.521 21.007C9.521 20.772 9.512 20.093 9.508 19.205C6.726 19.803 6.139 17.852 6.139 17.852C5.685 16.661 5.029 16.354 5.029 16.354C4.121 15.738 5.098 15.751 5.098 15.751C6.101 15.823 6.629 16.776 6.629 16.776C7.521 18.312 8.97 17.872 9.539 17.616C9.631 16.969 9.889 16.529 10.175 16.279C7.955 16.027 5.62 15.165 5.62 11.303C5.62 10.174 6.009 9.254 6.649 8.532C6.546 8.279 6.203 7.266 6.747 5.884C6.747 5.884 7.586 5.615 9.497 6.92C10.294 6.698 11.147 6.587 12 6.583C12.853 6.587 13.706 6.698 14.504 6.92C16.414 5.615 17.251 5.884 17.251 5.884C17.797 7.266 17.453 8.279 17.351 8.532C17.992 9.254 18.378 10.174 18.378 11.303C18.378 15.175 16.039 16.024 13.813 16.271C14.172 16.579 14.491 17.189 14.491 18.119C14.491 19.456 14.479 20.531 14.479 20.807C14.479 21.075 14.659 21.386 15.166 21.489C19.137 20.122 22 16.419 22 12C22 6.477 17.523 2 12 2Z"
          fill={fill}
        />
      </svg>
    );
  }
);